export default {
  ResinvoiceHistory: "سجل الفواتير",
  RessearchInvoice: "ابحث برقم الفاتورة...",
  ResnoInvoices: "لا توجد فواتير",
  Resinvoice: "الفاتورة",
  Resorder: "الطلب",
  Resdate: "التاريخ",
  Restotal: "المجموع",
  Resstatus: "الحالة",
  Resview: "عرض",
};